export interface AnalysisSimulatorState {
  list: AnalysisSimulatorData[] | undefined;
  detail: AnalysisSimulatorData | undefined;
  count: number | 0;
  log: AnalysisSimulatorLogData[] | undefined;
  searchParams: string;
  stcsList: AnalysisSimulatorStcsData[] | undefined;
  stcsCount: number | 0;
  page: number | 1;
  total: number | 0;
}

export interface AnalysisSimulatorData {
  cntrlId: string;
  idntfNum: string;
  flghtStDt: Date;
  flghtEndDt: Date;
  cntrlStDt: Date;
  cntrlEndDt: Date;
  ttlTime: number;
  ttlTimeType: string;
  ttlDstnc: number;
  ttlDstncType: string;
  avrgSpeed: number;
  avrgSpeedType: string;
  bttrCnsmptn: number;
  stArea: string;
  endArea: string;
  arcrftTypeCd: string;
  prdctNum: string;
  arcrftModelNm: string;
  imageUrl: string;
}

export interface AnalysisSimulatorLogData {
  hstrySno: number;
  cntrlId: string;
  trmnlId: string;
  mssgTypeCd: string;
  statusCd: string;
  lat: number;
  lon: number;
  speed: number;
  speedType: string;
  heading: number;
  elev: number;
  elevType: string;
  mvDstnc: number;
  bttrLvl: number;
  bttrVltg: number;
  trmnlRcvDt: string;
  srvrRcvDt: string;
}

export interface AnalysisSimulatorStcsData {
  dateCd: string;
  timeCd: string;
  avrgSpeed: number;
  speedType: string;
  avrgElev: number;
  elevType: string;
  avrgMvDstnc: number;
  mvDstncType: string;
  minBttrLvl: number;
  maxBttrLvl: number;
}

export const initResponseAnalysisSimulatorData = {
  list: undefined,
  detail: undefined,
  count: 0,
  log: undefined,
  searchParams: '',
  stcsList: undefined,
  stcsCount: 0,
  page: 1,
  total: 0
};
